import { DataBean } from "../DataBean";

export class Absenteeism extends DataBean {


    public async getAbsenteeismCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getAbsenteeismCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    public async getAbsenteeismCatalogByPropertiesRender(page:any,maxRows:any,properties): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_getAbsenteeismCatalogByPropertiesRender_Number_Number_java.util.Map", [page,maxRows,properties]);
    }
    
 
}